export default __webpack_public_path__ + "static/media/wife1.8378d564.png";